module.exports = __webpack_public_path__ + "img/record.d810f0fe.jpg";